import { render } from "./SpinnerBlock.vue?vue&type=template&id=6d8ee8a3"
import script from "./SpinnerBlock.vue?vue&type=script&lang=js"
export * from "./SpinnerBlock.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__